import { z } from 'zod';

export const PreviewConfigsSchema = z.object({
  backgroundImage: z.string().optional(),
});

export type PreviewConfigsDTO = z.infer<typeof PreviewConfigsSchema>;
